<template>
  <div ref="tabbar" :class="['emd-tabbar', classList]">
    <ul class="emd-tabbar__list">
      <li class="emd-tabbar__item" v-for="item in visibleItems" :key="item.label.key">
        <component
          :is="item.to ? 'router-link' : 'a'"
          :href="item.to || item.href || 'javascript:void(0);'"
          :to="item.to"
          class="emd-tabbar__link"
          :class="{ '_active': item.label.key === activeItem }"
          @click="action(item)">
          <emerald-icon v-if="item.emeraldicon" :icon="item.emeraldicon" />
          <i v-if="item.icon" :class="[`emd-text uil uil-${item.icon}`, itemClass]"></i>
          <span :class="itemClass">
            {{ item.label.value }}
          </span>
        </component>
      </li>
    </ul>
  </div>
</template>

<script>
import EmeraldIcon from '../../atoms/emeraldIcon/EmeraldIcon.vue'

export default {
  name: 'EmdTabbar',
  components: {
    EmeraldIcon
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    activeItem: {
      type: [String, Number],
      required: true
    },
    color: {
      type: String,
      required: false,
      default: null,
      validator: (value) => {
        return ['primary', 'secondary', 'tertiary', null].indexOf(value) !== -1
      }
    },
    bordered: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: String,
      required: false,
      default: null,
      validator: (value) => {
        return ['small', null].indexOf(value) !== -1
      }
    },
    justify: {
      type: String,
      required: false,
      default: null,
      validator: (value) => {
        return ['space-around', 'space-between', null].indexOf(value) !== -1
      }
    },
    itemClass: {
      type: String,
      required: false,
      default: 'emd-text'
    }
  },
  computed: {
    classList () {
      var classList = []
      if (this.bordered) {
        classList.push('_bordered')
      }
      if (this.size && this.size !== '') {
        classList.push(`_size_${this.size}`)
      }
      if (this.justify) {
        classList.push(`_justify_${this.justify}`)
      }
      if (this.color) {
        classList.push(`_color_${this.color}`)
      }
      return classList
    },
    visibleItems () {
      return this.items.filter(item => !item.hidden)
    }
  },
  mounted () {
    const $tabbar = this.$refs.tabbar
    let startX
    let scrollLeft
    let isDown = false
    if ($tabbar) {
      $tabbar.addEventListener('mousewheel', function (e) {
        e.preventDefault()
        $tabbar.scrollLeft += e.deltaY
      }, false)

      $tabbar.addEventListener('mousedown', function (e) {
        isDown = true
        startX = e.pageX - $tabbar.offsetLeft
        scrollLeft = $tabbar.scrollLeft
      }, false)

      $tabbar.addEventListener('mousemove', function (e) {
        if (!isDown) return
        const x = e.pageX - $tabbar.offsetLeft
        const walk = (x - startX) * 2
        $tabbar.scrollLeft = scrollLeft - walk
      }, false)

      $tabbar.addEventListener('mouseup', function (e) {
        isDown = false
      }, false)

      $tabbar.addEventListener('touchstart', function (e) {
        isDown = true
        if (e.touches.length > 0) {
          startX = e.touches[0].pageX - $tabbar.offsetLeft
        } else {
          startX = e.pageX - $tabbar.offsetLeft
        }
        scrollLeft = $tabbar.scrollLeft
      }, false)

      $tabbar.addEventListener('touchmove', function (e) {
        if (!isDown) return
        var x
        if (e.touches.length > 0) {
          x = e.touches[0].pageX - $tabbar.offsetLeft
        } else {
          x = e.pageX - $tabbar.offsetLeft
        }
        const walk = (x - startX) * 2
        $tabbar.scrollLeft = scrollLeft - walk
      }, false)

      $tabbar.addEventListener('touchend', function (e) {
        isDown = false
      }, false)
    }
  },
  methods: {
    action (item) {
      this.$emit('changed', item.label)
    }
  }
}
</script>

<style>
.emd-tabbar .emeraldicons {
  height: 16px;
  width: 16px;
  vertical-align: -2px;
  margin-right: 8px;
}
</style>
